// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3DzAM","left":"StickyBox_left__2ZIWr","right":"StickyBox_right__3NKYv"};